import { useEffect, useRef } from "react";
import useApi from "../../../../Utils/BackendClient";
import { Toast } from "primereact/toast";
import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";

import commonStyle from "../../CommonStyles.module.css";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import { Column } from "primereact/column";
import ProductStatusCircle from "../../../UIElements/ProductStatusCircle";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { useContext } from "react";
import EnumsContext from "../../../../context/enums-context";
import BrandCreationSidebar from "../../../UIElements/Sidebars/BrandCreationSidebar";
import { TabMenu } from "primereact/tabmenu";
import CustomDictionaryCreationSideBar from "../../../UIElements/Sidebars/CustomDictionaryCreationSidebar";
import AttributeCreationSidebar from "../../../UIElements/Sidebars/AttributeCreationSidebar";

const Dictionaries = () => {

    const toast = useRef();

    const ctx = useContext(EnumsContext);

    const { deleteBrandDictionary, deleteCustomDictionary, fetchBrandsDictionary, fetchCustomDictionaries, fetchCustomDictionaryById, fetchProductAttributes } = useApi();

    const [attribute, setAttribute] = useState(null);
    const [attributes, setAttributes] = useState(null);
    const [attributesLazyState, setAttributesLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters:{
            id: { value: null, matchMode: 'contains' },
        }
    });
    const [attributesTotalRecords, setAttributesTotalRecords] = useState(0);
    const [attributeSbVisible, setAttributeSbVisible] = useState(false);
    const [cdVisible, setCdVisible] = useState(false);
    const [customDictionaries, setCustomDictionaries] = useState(null);
    const [customDictionaryData, setCustomDictionaryData] = useState(null);
    const [customDictionaryLazyState, setCustomDictionaryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
    });
    const [customDictionariesTotalRecords, setCustomDictionariesTotalRecords] = useState(0);
    const [dictionaries, setDictionaries] = useState(null);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
    });
    const [loading, setLoading] = useState(true);
    const [reloadData, setReloadData] = useState(true);
    const [tabShowed, setTabShowed] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);

    useEffect(() => {

        const fetchData = async () => {

            const response = await fetchBrandsDictionary(lazyState);

            if (response.status !== 200) {
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            else {
                setTotalRecords(response.data.count);
                setDictionaries(response.data.results);

                console.log(response.data.results);
            }

            setLoading(false);
        }

        fetchData();

    }, [reloadData, lazyState, fetchBrandsDictionary]);

    const menuItems = [{
        label: "Бренди",
        command: () => {
            setTabShowed(0);
        }

    },
    {
        label: "Довідники",
        command: () => {
            setTabShowed(1);
            getCustomDictionariesList(customDictionaryLazyState);
        }
    },
    {
        label: "Атрибути",
        command: () => {
            setTabShowed(2);
            getAttributesList(attributesLazyState);
        }
    }
    ]

    const AddNewDictionaryValue = () => {
        if (tabShowed === 0) {
            setVisible(true);
        }
        else if(tabShowed === 1){
            setCdVisible(true);
        }
        else {
            setAttributeSbVisible(true);
        }
    }

    const getCustomDictionariesList = async (lazyState) => {

        const response = await fetchCustomDictionaries(lazyState);

        if (response.status === 200) {
            setCustomDictionaries(response.data.results);
            setCustomDictionariesTotalRecords(response.data.count);
        }
        else {
            DisplayErrors(response.error, toast);
        }
    }

    const getAttributesList = async (lazyState) => {

        const response = await fetchProductAttributes(lazyState);

        if(response.status === 200){
            setAttributes(response.data.results);
            setAttributesTotalRecords(response.data.count);
        }
        else{
            DisplayErrors(response.error, toast); 
        }
    }

    const toolbarRightTemplate = () => {
        const buttonName = tabShowed === 0 ? "Додати новий бренд" : (tabShowed === 1 ? "Додати новий довідник" : "Додати новий атрибут");
        return (<div className="flex flex-wrap gap-2">
            <Button label={buttonName} severity="success" className={commonStyle.addButton} onClick={AddNewDictionaryValue} />
        </div>)
    }

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onCustomDictionaryPage = (event) => {
        event.page = event.page + 1;
        getCustomDictionariesList(event);

        setCustomDictionaryLazyState(event);
    }

    const onAttributesPage = (event) => {
        event.page = event.page + 1;
        event.filters = attributesLazyState.filters;
        getAttributesList(event);

        setAttributesLazyState(event);
    }

    const DeleteBrandHandler = async (rowData) => {

        const response = await deleteBrandDictionary(rowData.id);

        if (response.status === 204) {
            toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Бренд успішно видалено', life: 3000 });
            ctx.resetEnum("brands_dictionary");
        }
        else {
            DisplayErrors(response.error, toast);
        }

        setReloadData(!reloadData);
    }

    const DeleteCustomDictionaryHandler = async (rowData) => {
        const response = await deleteCustomDictionary(rowData.id);

        if (response.status === 204) {
            toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Довідник успішно видалено', life: 3000 });

            getCustomDictionariesList(customDictionaryLazyState);
        }
        else {
            DisplayErrors(response.error, toast);
        }
    }

    const confirmDelete = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: 'Підтвердження видалення бренду',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            accept: () => { DeleteBrandHandler(rowData) }
        });
    }

    const confirmCustomDictionaryDelete = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: 'Підтвердження видалення довідника ' + rowData.name,
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            accept: () => { DeleteCustomDictionaryHandler(rowData) }
        });
    }

    const editCustomDictionary = async (rowData) => {
        const response = await fetchCustomDictionaryById(rowData.id);

        if (response.status === 200) {
            setCustomDictionaryData(response.data);
            setCdVisible(true);
        }
        else {
            DisplayErrors(response.error, toast);
        }
    }

    const editAttribute = async (rowData) => {
        const response = await fetchProductAttributes({
            first: 0,
            rows: 10,
            page: 1,
            sortField: null,
            sortOrder: null,
            filters: {
                id: { value: rowData.id, matchMode: 'equals' },
            }
        });

        console.log(response.data.results);
        console.log(response.data.results.length);

        if (response.status === 200) {
            if(response.data.results && response.data.results.length > 0)
            {
                setAttribute(response.data.results[0]);
                setAttributeSbVisible(true);
            }
        }
        else{
            DisplayErrors(response.error, toast);
        }
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-trash"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                tooltip="Видалити"
                tooltipOptions={{ position: "top" }}
                size="small"
                onClick={(event) => confirmDelete(event, rowData)}
            />
        )
    }

    const customDictionaryActionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-times"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                onClick={(event) => { confirmCustomDictionaryDelete(event, rowData) }}
            />
            <Button
                icon="pi pi-pencil"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                onClick={() => { editCustomDictionary(rowData) }}
            />
        </div>);
    }

    const attributeActionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-times"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                onClick={(event) => { console.log(event, rowData) }}
            />
            <Button
                icon="pi pi-pencil"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                onClick={() => { editAttribute(rowData) }}
            />
        </div>);
    }

    return (
        <>
            <Toast ref={toast} />
            <Toolbar className="mb-4" end={toolbarRightTemplate} />
            <TabMenu model={menuItems} />
            {tabShowed === 0 && <DataTable value={dictionaries} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} tableStyle={{ minWidth: '60rem' }} >
                <Column field="id" header="ID" sortable />
                <Column field="name" header="Назва" />
                <Column field="is_active" header="Статус" body={(rowData => <ProductStatusCircle id={rowData.id} type="statusCircle" isActive={rowData.is_active} />)} />
                <Column field="action" body={actionBodyTemplate} />
            </DataTable>}
            {tabShowed === 1 && <DataTable value={customDictionaries} stripedRows lazy rows={customDictionaryLazyState.rows} paginator onPage={onCustomDictionaryPage} first={customDictionaryLazyState.first} loading={loading} totalRecords={customDictionariesTotalRecords} rowsPerPageOptions={[10, 20, 50]} >
                <Column field="id" header="ID" sortable />
                <Column field="name" header="Назва довідника" sortable />
                <Column field="action" body={customDictionaryActionBodyTemplate} />
            </DataTable>
            }
            {tabShowed === 2 && <DataTable value={attributes} stripedRows lazy rows={attributesLazyState.rows} paginator onPage={onAttributesPage} first={attributesLazyState.first} loading={loading} totalRecords={attributesTotalRecords} rowsPerPageOptions={[10, 20, 50]} >
                <Column field="id" header="ID" sortable />
                <Column field="name" header="Назва довідника" />
                <Column field="description" header="Опис" />
                <Column field="action" body={attributeActionBodyTemplate} />
            </DataTable>
            }
            <ConfirmPopup group="headless" />
            <BrandCreationSidebar visible={visible} onHide={() => setVisible(false)} toast={toast} ctx={ctx} additionalActions={() => setReloadData(!reloadData)} />
            <CustomDictionaryCreationSideBar visible={cdVisible} onHide={() => setCdVisible(false)} toast={toast} data={customDictionaryData} additionalActions={() => getCustomDictionariesList(customDictionaryLazyState)} />
            <AttributeCreationSidebar visible={attributeSbVisible} onHide={() => setAttributeSbVisible(false)} toast={toast} data={attribute} additionalActions={() => getAttributesList(attributesLazyState)}/>
        </>
    )
}

export default Dictionaries;